module.exports = __webpack_public_path__ + "media/images/es_419/goals-segment-2194992be7c5fffe2f8f7beb294baa64.jpg";